import {
    FunctionName,
    MemberApiEndpoints,
    SLResponse, weworkEndpoints
} from "shared/functions/common";

import Config from "../../Config/Config";
import { NetworkService } from "../../Network/NetworkService";
import {
    ISignupResetStateRequest,
    ISignupCreateRequest,
    IWeWorkApplicationRequest,
    IQuickSignUpRetriveStateRequest,
    IQuickSignUpSetStateRequest,
    ISBALoanSetStateRequest,
    ISBALoanRoutingNumberRequest
} from "shared/functions/membersApi/types/ISignupProcess";


export default class FirebaseSignUpService {
    public static myAccountBasePath(endPoint: MemberApiEndpoints) {
        const baseUrl = Config.cloudFunctionsUrl();
        return `${baseUrl}/${FunctionName.membersApi}/${endPoint}`;
    }

    public static weWorkApplicationsBasePath(endPoint: weworkEndpoints) {
        const baseUrl = Config.cloudFunctionsUrl();
        return `${baseUrl}/${FunctionName.weWork}/${endPoint}`;
    }

    public static async post<T>(url: string, params: any) {
        return NetworkService.post<SLResponse<T>>(url, params);
    }

    public static async get<T>(url: string, query: any, headers?: any) {
        return NetworkService.get<SLResponse<T>>(url, query, headers);
    }

    public static createUser(params: ISignupCreateRequest) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.createSignupState);
        return FirebaseSignUpService.post<any>(url, params);
    }

    public static resetUser(params: ISignupResetStateRequest) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.resetSignupState);
        return FirebaseSignUpService.post<any>(url, params);
    }

    public static updateUser (params: any) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.updateSignupState);
        return FirebaseSignUpService.post<any>(url, params);
    }

    public static retrieveUserData (params: any) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.getSignupState);
        return FirebaseSignUpService.get<any>(url, params, params);
    }

    public static createWeWorApplication(params: IWeWorkApplicationRequest) {
        const url = FirebaseSignUpService.weWorkApplicationsBasePath(weworkEndpoints.weWorkApplication);
        return FirebaseSignUpService.post<any>(url, params);
    }

    public static retrieveLendioUserData (params: IQuickSignUpRetriveStateRequest) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.getQuickSignUpApplication);
        return FirebaseSignUpService.get<any>(url, params);
    }

    public static updateLendioUserData (params: IQuickSignUpSetStateRequest) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.setQuickSignUpApplication);
        return FirebaseSignUpService.post<any>(url, params);
    }

    public static createSBALoanApplication (params: ISBALoanSetStateRequest) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.setSBALoanSignupState);
        return FirebaseSignUpService.post<any>(url, params);
    }

    public static getBankNameFromRoutingNumber (params: ISBALoanRoutingNumberRequest) {
        const url = FirebaseSignUpService.myAccountBasePath(MemberApiEndpoints.getBankName);
        return FirebaseSignUpService.get<any>(url, params);
    }
}


// WEBPACK FOOTER //
// ./src/services/firebase/functions/FirebaseSignUpService.ts